import { ONBOARDING_THREAD_ID } from '@/utils/constants';

export const onboardingMessagesDE = {
  'step-0': {
    messages: {
      role: 'ai',
      content: [],
    },
  },
  'step-1': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-0',
          timestamp: '2024-11-21T06:35:39.224335+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content:
            'Welche Fahrer benötigen Unterstützung aufgrund einer Gesamtbewertung unter 70 im Durchschnitt im vergangenen Monat und wie lauten ihre Bewertungen?',
        },
        {
          id: 'onb-1',
          timestamp: '2024-11-21T06:36:09.224354+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
            x_axis: 'Fahrer Name',
          },
          content:
            'Im Zeitraum vom 1. Juni 2026 bis 30. Juni 2026 wurden 12 Fahrer mit einer durchschnittlichen Gesamtbewertung unter 70 identifiziert.\n\n' +
            '```json\n\n' +
            '{"table": [{"Fahrer Name": "Lucas Auernhammer", "Gesamtbewertung": 23.0}, {"Fahrer Name": "Christian Scheunemann", "Gesamtbewertung": 25.0}, {"Fahrer Name": "Bruno Ranft", "Gesamtbewertung": 26.0}, {"Fahrer Name": "Ute Meyjohann", "Gesamtbewertung": 26.0}, {"Fahrer Name": "Erhard Brauer", "Gesamtbewertung": 28.0}, {"Fahrer Name": "Margit Br\\u00fcck", "Gesamtbewertung": 28.0}, {"Fahrer Name": "Torsten Mustermann", "Gesamtbewertung": 39.0}, {"Fahrer Name": "Marius Mehl", "Gesamtbewertung": 42.0}, {"Fahrer Name": "Thomas Mustermann", "Gesamtbewertung": 43.0}, {"Fahrer Name": "Bernd M\\u00fcller", "Gesamtbewertung": 44.0}, {"Fahrer Name": "Maik Fleischhauer", "Gesamtbewertung": 44.0}, {"Fahrer Name": "Sabine Lindenmann", "Gesamtbewertung": 48.0}]}\n```' +
            '\n\nDa die Frage explizit nach Fahrern fragt, die Unterstützung benötigen, folgt eine detaillierte Analyse:\n\n' +
            '**Kritischer Bereich (unter 30 Punkte):**\n\n' +
            'Lucas Auernhammer, Christian Scheunemann, Bruno Ranft, Ute Meyjohann, Erhard Brauer und Margit Brück weisen die niedrigsten Gesamtbewertungen auf und haben den dringendsten Handlungsbedarf. Für diese Fahrer wird eine sofortige individuelle Betreuung empfohlen.\n\n' +
            '**Mittlerer Bereich (30–50 Punkte):**\n\n' +
            'Torsten Mustermann, Marius Mehl, Thomas Mustermann, Bernd Müller, Maik Fleischhauer und Sabine Lindenmann liegen im mittleren Bereich. Auch sie liegen deutlich unter dem Zielwert von 70 Punkten und sollten gezielt gefördert werden.\n\n' +
            '**Empfohlene Maßnahmen:**\n\n' +
            '- Gezielte Einzelcoachings für Fahrer im kritischen Bereich, insbesondere zu den Bereichen Segeln, Bremsen, Tempomat-Nutzung und Geschwindigkeitsüberschreitung.\n\n' +
            '- Regelmäßige Leistungsüberprüfungen, um Fortschritte zu verfolgen.\n\n' +
            '- Einsatz des MAN ProfiDrive Trainingsprogramms oder des Connected CoDriver zur kontinuierlichen Effizienzverbesserung im Fahralltag.',
        },
      ],
    },
  },

  'step-2': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-2',
          timestamp: '2024-11-21T06:36:39.224360+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content: 'Was ist der Grund für die niedrige Bewertung von Lucas Auernhammer?',
        },
        {
          id: 'onb-3',
          timestamp: '2024-11-21T06:37:09.224366+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
          },
          content:
            'Hier sind die detaillierten Fahrbewertungen von **Lucas Auernhammer** für den Zeitraum vom 1. Juli 2026 bis 31. Juli 2026:\n\n' +
            '```json\n\n' +
            '{"table":[{"KPI":"Fahrer Name","":"Lucas Auernhammer"},{"KPI":"Bewertung Schubbetrieb","":20.0},{"KPI":"Bewertung des Bremsverhaltens","":15.0},{"KPI":"Gaspedal-Bewertung","":30.0},{"KPI":"Bewertung Einsatz Geschwindigkeitsregelung","":50.0},{"KPI":"Bewertung Overspeed","":0.0}]}\n' +
            '```\n\n' +
            'Die niedrige Gesamtbewertung von Lucas Auernhammer ergibt sich aus schwachen Werten in allen fünf Kategorien. Die gravierendsten Probleme sind:\n\n' +
            '- **Überschreitung der Höchstgeschwindigkeit (0 Punkte)**: Dies ist der kritischste Befund. Lucas überschreitet regelmäßig und erheblich die zulässigen Höchstgeschwindigkeiten.\n\n' +
            '- **Bremsverhalten (15 Punkte)**: Der sehr niedrige Wert deutet auf hartes oder abruptes Bremsen hin, was auf zu geringen Sicherheitsabstand oder mangelnde Vorausschau hindeutet.\n\n' +
            '- **Schubbetrieb (20 Punkte)**: Der Schubbetrieb wird kaum genutzt, was auf eine ineffiziente Fahrweise hinweist.\n\n' +
            '- **Gaspedal/Beschleunigung (30 Punkte)**: Ein zu aggressives Beschleunigen reduziert die Effizienz erheblich.\n\n' +
            '- **Tempomat (50 Punkte)**: Der Tempomat wird zu selten eingesetzt, was die Kraftstoffeffizienz weiter verringert.\n\n' +
            'Insgesamt zeigt Lucas Auernhammer in allen Bereichen erheblichen Verbesserungsbedarf. Ein gezieltes Fahrertraining, insbesondere zur Geschwindigkeitseinhaltung und vorausschauenden Fahrweise, wird dringend empfohlen. MAN ProfiDrive bietet entsprechende Schulungsprogramme, die auf diese Schwachstellen ausgerichtet sind.',
        },
      ],
    },
  },

  'step-3': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-4',
          timestamp: '2024-11-21T06:37:39.224372+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content: 'Wie setzt sich die Bremsleistung zusammen?',
        },
        {
          id: 'onb-5',
          timestamp: '2024-11-21T06:38:09.224378+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          content:
            'Die **Bremsbewertung** setzt sich aus zwei Kriterien zusammen:\n\n' +
            '**1. Verhältnis verschleißfreie Bremse zur Betriebsbremse**\n\n' +
            'Es wird verglichen, wie viel des abgebremsten Weges mit der **Motorbremse oder dem Retarder** (verschleißfrei) gegenüber der **Betriebsbremse** zurückgelegt wurde.\n\n' +
            '**2. Anteil der Betriebsbremse an der Gesamtfahrstrecke**\n\n' +
            'Der Anteil der Strecke, auf dem die Betriebsbremse eingesetzt wurde, wird in Relation zur Gesamtfahrstrecke betrachtet.\n\n' +
            '---\n\n' +
            '**Bewertungsgrenzen:**\n\n' +
            '- **100 %:** Verhältnis verschleißfreie Bremse zu Betriebsbremse ≥ 5:1 **und** weniger als 1 % der Strecke mit Betriebsbremse gebremst.\n\n' +
            '- **0 %:** Verhältnis ≤ 0,5:1 **und** über 5,5 % der Strecke mit Betriebsbremse gebremst.\n\n' +
            '---\n\n' +
            '**Empfehlung:** Fahrer sollten möglichst häufig die Motorbremse oder den Retarder nutzen und vorausschauend fahren, um den Einsatz der Betriebsbremse zu minimieren – das verbessert sowohl die Bewertung als auch die Effizienz.\n\n' +
            'Basierend auf den folgenden Dokumenten:\n\n' +
            '1. [Perform Webinar 1 - Seite 4](https://fleetassistant.rio.cloud/docs/language=DE/market=all/Perform_Webinar_1.pdf#page=4)\n' +
            '2. [Perform Webinar 1 - Seite 5](https://fleetassistant.rio.cloud/docs/language=DE/market=all/Perform_Webinar_1.pdf#page=5)\n' +
            '3. [202602 Perform Ratings DE - Seite 5](https://fleetassistant.rio.cloud/docs/language=DE/market=all/202602_Perform_Ratings_DE.pdf#page=5)\n' +
            '4. [Perform Webinar 1 - Seite 6](https://fleetassistant.rio.cloud/docs/language=DE/market=all/Perform_Webinar_1.pdf#page=6)\n' +
            '5. [Perform Fahrerbewertung 1 - Seite 3](https://fleetassistant.rio.cloud/docs/language=DE/market=all/Perform_Fahrerbewertung_1.pdf#page=3)',
        },
      ],
    },
  },

  'step-4': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-6',
          timestamp: '2024-11-21T06:38:39.224384+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content:
            'Was kann mein Fahrer Lucas Auernhammer, der ein niedriges Bremsrating hat, tun, um sich zu verbessern?',
        },
        {
          id: 'onb-7',
          timestamp: '2024-11-21T06:39:09.224403+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
          },
          content:
            'Lucas Auernhammer weist im Zeitraum vom 21. Juli 2026 bis 20. August 2026 ein Bremsrating von lediglich **20 %** auf – ein sehr niedriger Wert mit erheblichem Verbesserungspotenzial.\n\n' +
            '- **KPI** Fahrer Name: Lucas Auernhammer\n' +
            '- **KPI** Bewertung des Bremsverhaltens: 20.0\n\n' +
            '## Konkrete Maßnahmen zur Verbesserung des Bremsverhaltens\n\n' +
            '### 1. Vorausschauend fahren – der Kern des Problems\n\n' +
            'Der häufigste Grund für ein schlechtes Bremsrating ist zu spätes Reagieren auf Verkehrssituationen. Lucas sollte:\n\n' +
            '- **Frühzeitig vom Gas gehen**, bevor eine Bremsung notwendig wird.\n' +
            '- **Größeren Sicherheitsabstand** einhalten.\n' +
            '- Geschwindigkeit stets dem Fahrbahnzustand, der Sicht und der Verkehrssituation anpassen.\n\n' +
            '### 2. Schubbetrieb gezielt einsetzen\n\n' +
            'Wenn Lucas das Gaspedal frühzeitig loslässt, übernimmt der Motor die Verzögerung, wodurch weniger Betriebsbremsungen nötig sind. Dies verbessert gleichzeitig das Bremsrating und das Schubbetrieb-Rating.\n\n' +
            '### 3. Situationsgerechte Geschwindigkeitsanpassung\n\n' +
            '- Kurven, Kreuzungen und Staus frühzeitig erkennen.\n' +
            '- Geschwindigkeit rechtzeitig und sanft reduzieren.\n' +
            '- Harte Bremsungen konsequent vermeiden.\n\n' +
            '### 4. Fahrer-Detailbericht zur Selbstreflexion nutzen\n\n' +
            'Der wöchentliche Fahrer-Detailbericht hilft dabei, kritische Situationen und Verbesserungen gegenüber der Vorwoche zu erkennen.\n\n' +
            '### 5. MAN ProfiDrive-Training in Betracht ziehen\n\n' +
            'MAN ProfiDrive unterstützt Fahrer gezielt beim kraftstoffsparenden und vorausschauenden Fahren.\n\n' +
            '### Sicherheitshinweis\n\n' +
            'Auch wenn der Fokus auf der Reduzierung von Bremsmanövern liegt, gilt: **Immer rechtzeitig und ausreichend mit dem Bremspedal bremsen**, wenn es die Situation erfordert.\n\n' +
            'Basierend auf den folgenden Dokumenten wurde die Antwort generiert (nach Relevanz sortiert):\n\n' +
            '1. [Perform Webinar 1 - Seite 6](https://fleetassistant.rio.cloud/docs/language=DE/market=all/Perform_Webinar_1.pdf#page=6)\n' +
            '2. [Perform Webinar 1 - Seite 5](https://fleetassistant.rio.cloud/docs/language=DE/market=all/Perform_Webinar_1.pdf#page=5)\n' +
            '3. [Perform Fahrerbewertung 1 - Seite 3](https://fleetassistant.rio.cloud/docs/language=DE/market=all/Perform_Fahrerbewertung_1.pdf#page=3)\n' +
            '4. [TGL Betriebsanleitung - Seite 186](https://fleetassistant.rio.cloud/docs/language=DE/market=all/TGL_Betriebsanleitung.pdf#page=186)',
        },
      ],
    },
  },
};
